document.addEventListener('DOMContentLoaded', function () {

    function usesBranchCollectionPagination() {
        const productGrid = document.getElementById('product-grid');
        return productGrid?.dataset.branchPagination === 'true' || productGrid?.dataset.branchPriceSort === 'true';
    }

    function normalizeBranchCollectionUrlParams(searchParams) {
        if (!usesBranchCollectionPagination()) {
            return searchParams;
        }

        const params = new URLSearchParams(searchParams || window.location.search.slice(1));

        if (params.has('page')) {
            params.set('branch_page', params.get('page'));
            params.delete('page');
        }

        params.delete('page');

        return params.toString();
    }

    function getUrlBranchPage() {
        const params = new URLSearchParams(window.location.search);
        const branchPage = parseInt(params.get('branch_page') || '1', 10);
        return Number.isNaN(branchPage) || branchPage < 1 ? 1 : branchPage;
    }

    function getRenderedBranchPage() {
        const productGrid = document.getElementById('product-grid');
        const fromGrid = parseInt(productGrid?.dataset.branchPage || '', 10);
        if (!Number.isNaN(fromGrid) && fromGrid > 0) return fromGrid;

        const fromPagination = parseInt(document.querySelector('.pagination-wrapper')?.dataset.page || '', 10);
        if (!Number.isNaN(fromPagination) && fromPagination > 0) return fromPagination;

        return 1;
    }

    function getCollectionSectionId() {
        return document.getElementById('product-grid')?.dataset?.id || '';
    }

    function fetchBranchCollectionSection() {
        const sectionId = getCollectionSectionId();
        if (!sectionId) return Promise.resolve(false);

        const params = new URLSearchParams(window.location.search);
        params.delete('page');
        const branchPage = getUrlBranchPage();
        params.set('branch_page', String(branchPage));

        const url = `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;

        return fetch(url)
            .then((response) => response.text())
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const productGridContainer = document.getElementById('ProductGridContainer');
                const newContainer = doc.getElementById('ProductGridContainer');

                if (!productGridContainer || !newContainer) {
                    return false;
                }

                productGridContainer.innerHTML = newContainer.innerHTML;

                const productCount = doc.getElementById('ProductCount');
                const productCountDesktop = doc.getElementById('ProductCountDesktop');
                const currentCount = document.getElementById('ProductCount');
                const currentCountDesktop = document.getElementById('ProductCountDesktop');

                if (productCount && currentCount) {
                    currentCount.innerHTML = productCount.innerHTML;
                }
                if (productCountDesktop && currentCountDesktop) {
                    currentCountDesktop.innerHTML = productCountDesktop.innerHTML;
                }

                sessionStorage.removeItem('dbmBranchPageSyncAttempt');

                if (typeof collectionPriceBasedOnBranch === 'function') {
                    collectionPriceBasedOnBranch();
                }

                return getUrlBranchPage() === getRenderedBranchPage();
            })
            .catch(() => false);
    }

    function syncBranchCollectionPagination() {
        if (!document.body.classList.contains('template-collection')) return;

        const productGrid = document.getElementById('product-grid');
        if (!usesBranchCollectionPagination()) return;

        const urlBranchPage = getUrlBranchPage();
        const renderedBranchPage = getRenderedBranchPage();

        if (urlBranchPage === renderedBranchPage) {
            sessionStorage.removeItem('dbmBranchPageSyncAttempt');
            return;
        }

        fetchBranchCollectionSection().then((success) => {
            if (success) return;

            const correctedRendered = getRenderedBranchPage();
            const params = new URLSearchParams(window.location.search);
            params.set('branch_page', String(correctedRendered));
            params.delete('page');
            window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
        });
    }

    function redirectLegacyCollectionPageParam() {
        if (!document.body.classList.contains('template-collection')) return;

        const params = new URLSearchParams(window.location.search);
        const hasBranch = localStorage.getItem('selectedBranch');
        if (!hasBranch?.trim() || !params.has('page') || params.has('branch_page')) return;

        params.set('branch_page', params.get('page'));
        params.delete('page');
        window.location.replace(`${window.location.pathname}?${params.toString()}`);
    }

    redirectLegacyCollectionPageParam();

    if (typeof FacetFiltersForm !== 'undefined') {
        const originalRenderPage = FacetFiltersForm.renderPage;
        FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash = true) {
            return originalRenderPage.call(
                this,
                normalizeBranchCollectionUrlParams(searchParams),
                event,
                updateURLHash
            );
        };

        const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
        FacetFiltersForm.renderProductGridContainer = function (html) {
            originalRenderProductGridContainer.call(this, html);
            syncBranchCollectionPagination();
            if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
                collectionPriceBasedOnBranch();
            }
        };
    }

    syncBranchCollectionPagination();

    // Quantity js start 
    document.querySelectorAll(".js-button").forEach(function (button) {
        button.addEventListener("click", function () {
            const input = this.parentElement.querySelector("input");
            let val = parseInt(input.value, 10);

            if (this.classList.contains("less")) {
                val = val - 1;
            } else if (this.classList.contains("more")) {
                val = val + 1;
            }

            if (val < 1) {
                val = 1;
            }

            input.value = val;
        });
    });
    // Quantity js end 

    if (document.getElementsByClassName('.scroll-top')) {
        document.querySelectorAll('.scroll-top').forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        });
    }
    Fancybox.bind("[data-fancybox]", {
        mainClass: "dbm-popup-wrapper"
    });

    const toggleBtn = document.querySelector(".js-header-toggle");
    const mobileMenu = document.querySelector(".js-header-menu");
    const body = document.querySelector('body');

    toggleBtn.addEventListener("click", function () {
        body.classList.toggle('is-overlay');
        mobileMenu.classList.toggle("is-open");
        toggleBtn.classList.toggle("is-active");
    });

    const iframeMap = document.querySelector('.dbm-branch-locator__map iframe');
    const defaultMapLink = (window.dbmBranchLocator) ? window.dbmBranchLocator.defaultMapLink : "";

    /* nav megamenu */
    let navAttrLists = document.querySelectorAll("[data-level-id]");
    navAttrLists.forEach(navAttr => {
        navAttr.addEventListener("click", function (e) {
            e.preventDefault();
            let target = e.currentTarget;
            let levelId = target.dataset.levelId;

            let targetMenu = document.querySelector(levelId);
            if (targetMenu) {
                targetMenu.classList.toggle("active");
            }
        });
    });

    // Read Less More toggle 
    const readMoreButton = document.querySelector(".js-read-desc");
    function readMoreLess(event) {
        let description = event.target.closest(".js-description");
        let moreText = description.querySelector(".js-long-detail");
        let dots = description.querySelector(".dots");
        let btnText = event.target;

        if (!moreText) return;
        if (moreText.classList.contains("active")) {
            dots.style.display = "inline";
            btnText.innerHTML = "Read more";
            moreText.classList.remove("active");
        } else {
            dots.style.display = "none";
            btnText.innerHTML = "Read less";
            moreText.classList.add("active");
        }
    }
    readMoreButton?.addEventListener("click", function (event) {
        readMoreLess(event);
    });

    //related products carousel
    const relatedProductscarousel = document.querySelector('.js-related-products');
    if (relatedProductscarousel) {
        const items = relatedProductscarousel.querySelectorAll('.dbm-related-product__item');
        if (items.length > 4 || window.innerWidth <= 768) {
            new Flickity(relatedProductscarousel, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
            });
            
        }
    }

    const frequentlyBoughtTogether = document.querySelector('.js-frequently-bought-together');
    const customPrev = document.querySelector('.js-fbt-prev');
    const customNext = document.querySelector('.js-fbt-next');

    if (frequentlyBoughtTogether) {
        const flkty = new Flickity(frequentlyBoughtTogether, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false
        });

        // Attach custom arrow events
        customPrev?.addEventListener('click', () => flkty.previous());
        customNext?.addEventListener('click', () => flkty.next());
    }

    /* Branch location and delivery postcode scripts starts */
    const LS = localStorage;
    let branchUnavailableRedirecting = false;

    function hasValidDeliverySelection() {
        const postcode = LS.getItem('deliveryPostcode');
        const branch = LS.getItem('selectedBranch');

        const requiredSelected = postcode?.trim() &&
            window.branchesPostCodes?.some(branchPostcode => {
                const branchCode = branchPostcode.toLowerCase();
                const code = postcode.trim().toLowerCase();
                return branchCode.includes(code) || code.includes(branchCode);
            });

        const requiredSelectedBranch = branch && branch.trim() !== '';

        return requiredSelected && requiredSelectedBranch;
    }

    function getSelectedBranchVariantData() {
        const branch = LS.getItem('selectedBranch');
        if (!branch?.trim()) return null;

        const variantPricesContainer = document.querySelector('.all-variant-prices');
        if (!variantPricesContainer) return null;

        const variantPriceEl = variantPricesContainer.querySelector(
            `.variant-price[data-branch-variant="${CSS.escape(branch)}"]`
        );

        if (!variantPriceEl) return null;

        return {
            price: parseInt(variantPriceEl.dataset.variantPrice, 10),
            available: variantPriceEl.dataset.variantAvailable === 'true',
        };
    }

    function getSelectedBranchVariantPrice() {
        const data = getSelectedBranchVariantData();
        return data ? data.price : null;
    }

    function redirectToHomePage() {
        if (branchUnavailableRedirecting) return;
        branchUnavailableRedirecting = true;
        window.location.href = window.routes?.root_url || '/';
    }

    function showBranchUnavailableModal() {
        if (branchUnavailableRedirecting || window.dbmBranchUnavailableShown) return;
        if (window.Shopify?.designMode) return;

        window.dbmBranchUnavailableShown = true;

        const popup = document.getElementById('popup-branch-unavailable');
        if (!popup) {
            redirectToHomePage();
            return;
        }

        const messageEl = popup.querySelector('[data-branch-unavailable-message]');
        if (messageEl && window.dbmStrings?.branchUnavailableMessage) {
            messageEl.textContent = window.dbmStrings.branchUnavailableMessage;
        }

        const openModal = () => {
            if (typeof Fancybox !== 'undefined') {
                Fancybox.show([{
                    src: '#popup-branch-unavailable',
                    type: 'inline',
                    mainClass: 'dbm-popup-wrapper'
                }], {
                    dragToClose: false,
                    backdropClick: false,
                    on: {
                        destroy: redirectToHomePage
                    }
                });
            } else {
                alert(messageEl?.textContent || 'This product is not available for your selected branch.');
                redirectToHomePage();
            }
        };

        openModal();
    }

    function checkProductBranchZeroPrice() {
        if (!document.body.classList.contains('template-product')) return;
        if (!hasValidDeliverySelection()) return;

        const variantData = getSelectedBranchVariantData();
        if (!variantData || variantData.price < 1 || !variantData.available) {
            showBranchUnavailableModal();
        }
    }

    function scheduleBranchZeroPriceCheck() {
        if (!document.body.classList.contains('template-product')) return;
        window.clearTimeout(window.dbmBranchZeroPriceCheckTimer);
        window.dbmBranchZeroPriceCheckTimer = window.setTimeout(checkProductBranchZeroPrice, 500);
    }

    function shouldReloadForBranchPriceSort() {
        const sortBy = getCollectionSortBy();
        return document.body.classList.contains('template-collection') &&
            (sortBy === 'price-ascending' || sortBy === 'price-descending');
    }

    function syncBranchCartAttributes(options = {}) {
        const branch = LS.getItem('selectedBranch') || '';
        const postcode = LS.getItem('deliveryPostcode') || '';

        return fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                const currentBranch = cart.attributes?.selected_branch || '';
                const currentPostcode = cart.attributes?.delivery_postcode || '';

                if (currentBranch === branch && currentPostcode === postcode) {
                    return false;
                }

                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: {
                            selected_branch: branch,
                            delivery_postcode: postcode,
                        },
                    }),
                }).then(() => {
                    return true;
                });
            })
            .catch((error) => {
                console.error('Failed to sync branch cart attributes:', error);
                return false;
            });
    }

    document.addEventListener('click', (event) => {
        const continueBtn = event.target.closest('.js-branch-unavailable-continue');
        if (!continueBtn) return;
        event.preventDefault();
        redirectToHomePage();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
            scheduleBranchZeroPriceCheck();
        });
    }

    const postcodeKeys = [
        'delivery_postcode',
        'pdp_delivery_postcode',
        'category_delivery_postcode',
        // 'locator_delivery_postcode'
    ];
    const preSelectedPostCode = LS.getItem('deliveryPostcode') || '';
    const preselectedBranch = LS.getItem('selectedBranch') || '';
    const stickyWhatsappButton = document.querySelector('[data-whatsapp-branch-button]');

    let inputs = postcodeKeys.map(name => document.querySelector(`input[name="${name}"]`)).filter(Boolean);
    let branchEls = document.querySelectorAll(`[data-branch][data-postcode]`);
    const announcementSelectedBranchText = document.querySelectorAll(`[data-announcement-branch-text]`);

    const branchLocatorBtns = document.querySelectorAll('.dbm-branch-locator__list-box-btn a');

    function formatWhatsappPhone(phone) {
        if (!phone) return '';

        const trimmedPhone = phone.toString().trim();
        if (trimmedPhone.startsWith('+')) {
            return trimmedPhone.replace(/\D/g, '');
        }

        const digits = trimmedPhone.replace(/\D/g, '');
        if (!digits) return '';

        if (digits.startsWith('00')) {
            return digits.slice(2);
        }

        if (digits.startsWith('0')) {
            return `44${digits.slice(1)}`;
        }

        return digits;
    }

    function updateStickyWhatsappButton(selectedBranch = LS.getItem('selectedBranch')) {
        if (!stickyWhatsappButton) return;

        const branch = window.branches?.find(item => item.title === selectedBranch);
        const phone = formatWhatsappPhone(branch?.whatsapp_phone || branch?.phone);

        if (!branch || !phone) {
            stickyWhatsappButton.hidden = true;
            stickyWhatsappButton.removeAttribute('href');
            return;
        }

        const message = encodeURIComponent(`Hi DBM ${branch.title}, I would like to contact this branch.`);
        stickyWhatsappButton.href = `https://wa.me/${phone}?text=${message}`;
        stickyWhatsappButton.setAttribute('aria-label', `Contact ${branch.title} branch on WhatsApp`);
        stickyWhatsappButton.hidden = false;
    }

    // Function to reinitialize inputs and elements after AJAX
    function reinitializePostcodeElements() {
        inputs = postcodeKeys.map(name => document.querySelector(`input[name="${name}"]`)).filter(Boolean);
        branchEls = document.querySelectorAll(`[data-branch][data-postcode]`);
        const preSelectedPostCode = LS.getItem('deliveryPostcode') || '';
        const preselectedBranch = LS.getItem('selectedBranch') || '';
        // Set values
        inputs.forEach(input => input && (input.value = preSelectedPostCode));
        branchEls.forEach(el => {
            if (el.getAttribute('data-branch') === preselectedBranch) {
                el.classList.add('active');   
            }
        });
        updateStickyWhatsappButton(preselectedBranch);
    }

    // Set initial values and active branch
    reinitializePostcodeElements();
    
    let branchPostCodes = [];
    branchEls.forEach(el => {
        branchPostCodes.push(el.getAttribute('data-postcode'))
    });

    LS.setItem('branchPostCodes', branchPostCodes);
    updateAnnouncementSelectedBranchText();

    // Set initial values and active branch locator page
    
    function updateAnnouncementSelectedBranchText(preselectedBranch = LS.getItem('selectedBranch')) {
        announcementSelectedBranchText.forEach(el => {
            if (preselectedBranch && preselectedBranch.trim() !== '') {
                el.innerHTML = `Store Selected – <span class="underlined-text">${preselectedBranch}</span>`;
            } else {
                el.innerHTML = 'Branch Locator';
            }
        });
    }

    // Utility to show/hide product info/add-to-cart based on postcode/branch
    window.updateProductInfoVisibility = function () {
        const postcode = LS.getItem('deliveryPostcode');
        const branch = LS.getItem('selectedBranch');
        const cartDeliveryPostcode = document.querySelector('.cart-delivery-postcode');
        if (cartDeliveryPostcode) cartDeliveryPostcode.textContent = postcode;
        updateAnnouncementSelectedBranchText(branch);
        updateStickyWhatsappButton(branch);
        const branchPostCodes = LS.getItem('branchPostCodes');

        const requiredSelected = postcode?.trim() &&
            window.branchesPostCodes?.some(branchPostcode => {
                const branchCode = branchPostcode.toLowerCase();
                const code = postcode.trim().toLowerCase();
                return branchCode.includes(code) || code.includes(branchCode);
            });
        
        const requiredSelectedBranch = branch && branch.trim() !== '';
        [
            'product-banner__price-wrap',
            'volume-pricing-note',
            'product-banner__inc-vat-price',
            'product-banner__text-desc',
            'product-form__quantity',
            'product-form',
            'qty',
            'product__pickup-availabilities',
            'pay-less-badge',
            'card-information',
            'card__info',
            'dbm-price__wrapper',
            'dbm-price',
            'dbm-price__unit'
        ].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelected ? '' : 'none';
            });
        });

        ['dbm-header__pay']?.forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.visibility = requiredSelected ? '' : 'hidden';
            });
        });
        
        ['enter-delivery-postcode-btn'].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelected ? 'none' : '';
            });
        });
        ['enter-collection-branch-btn'].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelectedBranch ? 'none' : '';
            });
        });
        ['dbm-collection__delivery-options'].forEach(cls => {
            document.querySelectorAll('.' + cls).forEach(el => {
                el.style.display = requiredSelected && requiredSelectedBranch ? 'none' : '';
            });
        });
        document.querySelectorAll('.product-banner__price-availability').forEach(el => {
            el.style.display = requiredSelected ? 'none' : '';
        });
        if (document.body.classList.contains('template-product')) {
            loadProductVariantOnSelectedBranch();
            scheduleBranchZeroPriceCheck();
        }
        if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
            collectionPriceBasedOnBranch();
        }
        if (document.querySelector('.dbm-hero')) {
            updateHeroPriceBasedOnBranch();
        }
        document.querySelectorAll('[data-predictive-search]').forEach((container) => {
            if (container.innerHTML.trim() && window.filterPredictiveSearchByBranch) {
                window.filterPredictiveSearchByBranch(container);
            }
        });
        updateRecentProductsSection();
    }

    function getRecentProductBranchVariant(item, selectedBranch) {
        if (!selectedBranch?.trim()) return null;

        const normalizedBranch = selectedBranch.trim().toLowerCase();
        const variantPrices = item.querySelectorAll('.variant-price[data-branch-variant]');

        for (const el of variantPrices) {
            const branchVariant = (el.getAttribute('data-branch-variant') || '').trim().toLowerCase();
            if (branchVariant === normalizedBranch) {
                return {
                    price: parseInt(el.dataset.variantPrice, 10),
                    available: el.dataset.variantAvailable === 'true',
                };
            }
        }

        return null;
    }

    function isRecentProductUnavailableForBranch(item, selectedBranch) {
        if (!selectedBranch?.trim()) return false;

        const variantData = getRecentProductBranchVariant(item, selectedBranch);
        if (!variantData) return true;

        return Number.isNaN(variantData.price) || variantData.price < 1 || !variantData.available;
    }

    function updateRecentProductsSection() {
        const section = document.querySelector('.dbm-recent-products');
        const container = document.querySelector('.js-recent-products');
        if (!section || !container) return;

        const selectedBranch = LS.getItem('selectedBranch') || '';
        const items = Array.from(container.querySelectorAll('.dbm-recent-product__item'));

        items.forEach((item) => {
            const isUnavailable = isRecentProductUnavailableForBranch(item, selectedBranch);
            item.style.display = isUnavailable ? 'none' : '';
            item.classList.toggle('is-branch-unavailable', isUnavailable);
        });

        const visibleCount = items.filter((item) => item.style.display !== 'none').length;
        section.style.display = visibleCount > 0 ? '' : 'none';
    }

    function filterPredictiveSearchByBranch(container) {
        if (!container) return;

        const selectedBranch = LS.getItem('selectedBranch');
        const productList = container.querySelector('#predictive-search-results-products-list');
        if (!productList) return;

        if (!selectedBranch?.trim()) {
            productList.querySelectorAll('li.predictive-search__list-item').forEach((item) => {
                item.style.display = '';
            });
            const productsSection = container.querySelector('#predictive-search-products')?.closest('div');
            if (productsSection) productsSection.style.display = '';
            return;
        }

        let visibleCount = 0;
        productList.querySelectorAll('li.predictive-search__list-item').forEach((item) => {
            const variantPriceEl = getBranchVariantPriceEl(item, selectedBranch);
            const isUnavailable = isBranchVariantUnavailable(variantPriceEl);
            item.style.display = isUnavailable ? 'none' : '';
            if (!isUnavailable) visibleCount += 1;
        });

        const productsSection = container.querySelector('#predictive-search-products')?.closest('div');
        if (productsSection) {
            productsSection.style.display = visibleCount > 0 ? '' : 'none';
        }

        const groupsWrapper = container.querySelector('#predictive-search-results-groups-wrapper');
        if (groupsWrapper) {
            groupsWrapper.classList.toggle('predictive-search__results-groups-wrapper--no-products', visibleCount === 0);
        }
    }

    window.filterPredictiveSearchByBranch = filterPredictiveSearchByBranch;
    window.updateRecentProductsSection = updateRecentProductsSection;

    function getCollectionUrlAfterBranchChange(preserveSort = true) {
        const params = new URLSearchParams(window.location.search);
        let url = window.location.pathname;

        if (preserveSort && params.get('sort_by')) {
            url += `?sort_by=${encodeURIComponent(params.get('sort_by'))}`;
        }

        return url;
    }

    function clearCart() {
        return fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Cart clear failed');
            }
            return response.json();
        });
    }

    function reloadCartPageIfNeeded() {
        if (document.body.classList.contains('template-cart')) {
            window.location.reload();
            return true;
        }
        return false;
    }

    function clearCartThenContinue(onComplete) {
        return clearCart()
            .then(() => {
                if (reloadCartPageIfNeeded()) {
                    return;
                }
                if (typeof onComplete === 'function') {
                    return onComplete();
                }
            })
            .catch((error) => {
                console.error('There was a problem clearing the cart:', error);
                if (typeof onComplete === 'function') {
                    return onComplete();
                }
            });
    }

    function shouldClearCartForDeliveryChange(previousPostcode, newPostcode, previousBranch, newBranch) {
        const postcodeChanged = (previousPostcode || '').trim() !== (newPostcode || '').trim();
        const branchChanged = (previousBranch || '') !== (newBranch || '');
        return postcodeChanged || branchChanged;
    }

    function clearCartOnDeliveryChangeIfNeeded(previousPostcode, newPostcode, previousBranch, newBranch, onComplete) {
        if (!shouldClearCartForDeliveryChange(previousPostcode, newPostcode, previousBranch, newBranch)) {
            if (typeof onComplete === 'function') {
                return Promise.resolve(onComplete());
            }
            return Promise.resolve();
        }

        return fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                if (!cart.item_count) {
                    if (typeof onComplete === 'function') {
                        return onComplete();
                    }
                    return;
                }

                return clearCartThenContinue(onComplete);
            })
            .catch((error) => {
                console.error('Failed to check cart before clearing:', error);
                if (typeof onComplete === 'function') {
                    return onComplete();
                }
            });
    }

    function afterBranchSelectionChange(options = {}) {
        const {
            resetCollection = false,
            previousBranch = null,
            newBranch = LS.getItem('selectedBranch') || '',
        } = options;
        const branchChanged = previousBranch !== newBranch;
        const preserveSort = Boolean(newBranch);

        return syncBranchCartAttributes().then(() => {
            if (resetCollection && branchChanged && document.body.classList.contains('template-collection')) {
                window.location.href = getCollectionUrlAfterBranchChange(preserveSort);
                return;
            }

            if (branchChanged && shouldReloadForBranchPriceSort()) {
                window.location.reload();
                return;
            }

            updateProductInfoVisibility();
        });
    }

    // Reset function for postcode and branch selection
    function resetDeliverySelection() {
        const previousBranch = LS.getItem('selectedBranch');
        LS.removeItem('deliveryPostcode');
        LS.removeItem('selectedBranch');
        inputs.forEach(input => input && (input.value = ''));
        branchEls.forEach(el => el.classList.remove('active'));
        updateAnnouncementSelectedBranchText();
        afterBranchSelectionChange({
            resetCollection: true,
            previousBranch,
            newBranch: '',
        });
    }

    // Clear cart function on branch change
    document.addEventListener('click', e => {
        const link = e.target.closest("[data-branch][data-postcode]");
        if (!link) return;
        
        e.preventDefault();
        branchEls = document.querySelectorAll("[data-branch][data-postcode]");
        branchEls.forEach(el => el.classList.remove('active'));
        const branch = link.getAttribute('data-branch');
        const postcode = link.getAttribute('data-postcode');

        const previousBranch = LS.getItem('selectedBranch');

        LS.setItem('selectedBranch', branch);
        document.querySelectorAll(`[data-branch="${branch}"][data-postcode]`).forEach(el => el.classList.add('active'));
        inputs.forEach(input => input && (input.value = postcode));
        if (postcode) LS.setItem('deliveryPostcode', postcode);

        let preselectedBranchBtn = document.querySelector(`.dbm-branch-locator__list-box-btn a[data-btn-post-code="${postcode}"]`);
        if (preselectedBranchBtn) {
            preselectedBranchBtn.click();
        }
        
        const branchChangeOptions = {
            resetCollection: true,
            previousBranch,
            newBranch: branch,
        };

        if (previousBranch && branch !== previousBranch) {
            clearCartOnDeliveryChangeIfNeeded(
                LS.getItem('deliveryPostcode'),
                postcode,
                previousBranch,
                branch,
                () => afterBranchSelectionChange(branchChangeOptions)
            );
        } else {
            afterBranchSelectionChange(branchChangeOptions);
        }

        if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
            window.renderRecentlyViewedCarousel();
        }

    });

    // Handle delivery form submit
    postcodeKeys.forEach(name => {
        const form = document.getElementById(name.replace('_postcode', '-form'));
        if (form) {
            form.addEventListener('submit', e => {
                e.preventDefault();

                const previousBranch = LS.getItem('selectedBranch');
                const previousPostcode = LS.getItem('deliveryPostcode') || '';
                const input = form.querySelector(`input[name="${name}"]`);
                const newPostcode = input?.value?.trim() || '';
                if (input) LS.setItem('deliveryPostcode', newPostcode);

                if (name.includes('pdp')) {
                    const value = newPostcode;
                    if (value == "") {
                        resetDeliverySelection();
                        return;
                    }
                    
                    inputs = Array.from(document.querySelectorAll(postcodeKeys.map(n => `input[name="${n}"]`).join(',')));
                    inputs.forEach(otherInput => otherInput && (otherInput.value = value));
                    LS.setItem('deliveryPostcode', value);
                    if (value != "") {
                        const selectedBranch = window.branches.find(branch =>
                            branch.related_pincodes.some(pincode => {
                                const normalizedPincode = pincode.toLowerCase();
                                const normalizedValue = value.toLowerCase();
                                return normalizedPincode.includes(normalizedValue) ||
                                    normalizedValue.includes(normalizedPincode);
                            })
                        );
                        
                        branchEls.forEach(el => el.classList.remove('active'));
                        if (selectedBranch) {
                            LS.setItem('selectedBranch', selectedBranch ? selectedBranch.title : '');
                            document.querySelectorAll(`[data-branch="${selectedBranch.title}"][data-postcode]`).forEach(el => el.classList.add('active'));
                        }
                    }
                }

                const finishDeliveryFormSubmit = () => {
                    afterBranchSelectionChange({
                        resetCollection: true,
                        previousBranch,
                        newBranch: LS.getItem('selectedBranch') || '',
                    });
                    document.querySelector('[data-fancybox-close]')?.click();
                    if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
                        window.renderRecentlyViewedCarousel();
                    }
                };

                clearCartOnDeliveryChangeIfNeeded(
                    previousPostcode,
                    newPostcode,
                    previousBranch,
                    LS.getItem('selectedBranch') || '',
                    finishDeliveryFormSubmit
                );
            });
        }
    });

    // Use Current Location to get and set postcode
    document.querySelectorAll('.use-current-location').forEach(btn => {
        const buttonTextElement = btn.querySelector('span');
        btn.addEventListener('click', () => {
            resetDeliverySelection();
            if (!navigator.geolocation) return alert('Geolocation is not supported by your browser.');
            btn.disabled = true;
            buttonTextElement.textContent = 'Locating...';
            navigator.geolocation.getCurrentPosition(
                pos => {
                    const { latitude: lat, longitude: lon } = pos.coords;
                    fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`)
                        .then(r => r.json())
                        .then(data => {
                            const pincode = data.address?.postcode || '';
                            inputs.forEach(input => input && (input.value = pincode));
                            LS.setItem('deliveryPostcode', pincode);
                        })
                        .catch(() => alert('Could not fetch pincode.'))
                        .finally(() => {
                            btn.disabled = false;
                            buttonTextElement.textContent = 'Use Current Location';
                            setTimeout(updateProductInfoVisibility, 100);
                        });
                },
                () => {
                    // alert('Unable to retrieve your location.');
                    btn.disabled = false;
                    buttonTextElement.textContent = 'Use Current Location';
                }
            );
        });
    });

    document.addEventListener('input', (e) => {
        const input = e.target;
        if (!input.matches('[name$="_postcode"]')) return;
        
        const name = input.getAttribute('name');
        if (name && postcodeKeys.includes(name) && !name.includes('pdp')) {
            const previousBranch = LS.getItem('selectedBranch');
            const value = e.target.value;
            if (value == "") {
                resetDeliverySelection();
                return;
            }
            
            inputs = Array.from(document.querySelectorAll(postcodeKeys.map(n => `input[name="${n}"]`).join(',')));
            inputs.forEach(otherInput => otherInput && (otherInput.value = value));
            LS.setItem('deliveryPostcode', value);
            if (value != "") {
                const selectedBranch = window.branches.find(branch =>
                    branch.related_pincodes.some(pincode => {
                        const normalizedPincode = pincode.toLowerCase();
                        const normalizedValue = value.toLowerCase();
                        return normalizedPincode.includes(normalizedValue) ||
                            normalizedValue.includes(normalizedPincode);
                    })
                );
                branchEls.forEach(el => el.classList.remove('active'));
                if (selectedBranch) {
                    LS.setItem('selectedBranch', selectedBranch ? selectedBranch.title : '');
                    document.querySelectorAll(`[data-branch="${selectedBranch.title}"][data-postcode]`).forEach(el => el.classList.add('active'));
                }
            }
            afterBranchSelectionChange({
                resetCollection: true,
                previousBranch,
                newBranch: LS.getItem('selectedBranch') || '',
            });
        }
        if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
            window.renderRecentlyViewedCarousel();
        }
    });

    document.addEventListener('input', (e) => {
        const input = e.target;
        if (input.matches('[name="pdp_delivery_postcode"]')) return;
    });

    // Branch locator buttons - delegated for AJAX
    document.addEventListener('click', function (event) {
        const btn = event.target.closest('.dbm-branch-locator__list-box-btn a');
        if (!btn) return;
        
        event.preventDefault();
        const branchLocatorBtns = document.querySelectorAll('.dbm-branch-locator__list-box-btn a');
        const isActive = btn.classList.contains('active');
        if (!branchLocatorBtns) return; 
        branchLocatorBtns.forEach((el) => {
            el.classList.remove('active');
            el.textContent = 'Select branch';
        });

        let postCode = btn.getAttribute('data-btn-post-code');
        let branchTitle = btn.getAttribute('data-branch');
        const previousBranch = LS.getItem('selectedBranch');
        branchEls.forEach(el => el.classList.remove('active'));
        LS.setItem('selectedBranch', branchTitle);
        document.querySelectorAll(`[data-branch="${branchTitle}"][data-postcode]`).forEach(el => el.classList.add('active'));
        inputs.forEach(input => input && (input.value = postCode));
        if (postCode) LS.setItem('deliveryPostcode', postCode);
        afterBranchSelectionChange({
            resetCollection: true,
            previousBranch,
            newBranch: branchTitle,
        });
        if (!isActive) {
            btn.classList.add('active');
            btn.textContent = 'Selected';

            const dataLink = btn.getAttribute('data-link');
            if (iframeMap && dataLink) {
                iframeMap.setAttribute('src', dataLink);
            }
        } else {
            if (iframeMap && defaultMapLink) {
                iframeMap.setAttribute('src', defaultMapLink);
            }
        }
        if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
            window.renderRecentlyViewedCarousel();
        }
    });

    // Set initial data-original-text attribute - delegated for AJAX
    document.addEventListener('DOMNodeInserted', function() {
        document.querySelectorAll('.dbm-branch-locator__list-box-btn a:not([data-original-text])').forEach(el => {
            el.setAttribute('data-original-text', el.textContent.trim());
        });
    });

    if (branchLocatorBtns) {
        branchLocatorBtns.forEach(el => {
            if (el.getAttribute('data-branch') === preselectedBranch) {
                el.classList.add('active');
                el.textContent = 'Selected';

                const dataLink = el.getAttribute('data-link');
                if (iframeMap && dataLink) {
                    iframeMap.setAttribute('src', dataLink);
                }  else {
                    if (iframeMap && defaultMapLink) {
                        iframeMap.setAttribute('src', defaultMapLink);
                    }
                }
            } else {
                el.textContent = 'Select branch';
            }
        });
    }

    // Expose reinitialize function globally for AJAX callbacks
    window.dbmThemeReinit = function() {
        reinitializePostcodeElements();
        document.querySelectorAll('.dbm-branch-locator__list-box-btn a:not([data-original-text])').forEach(el => {
            el.setAttribute('data-original-text', el.textContent.trim());
        });
        // Reinitialize carousels
        recentProductsCarousel();
        // Reinitialize other dynamic elements
        updateProductInfoVisibility();
    };

    syncBranchCartAttributes().then((updated) => {
        if (!updated || !shouldReloadForBranchPriceSort()) {
            updateProductInfoVisibility();
        } else {
            window.location.reload();
        }
    });

    /* Branch location and delivery postcode scripts ends */

    /* Preselect branch variant on product page load starts */
    function loadProductVariantOnSelectedBranch() {
        const selectedBranch = LS?.getItem?.('selectedBranch');
        // 
        if (!selectedBranch) return;
        // Find select elements and match by value/text that includes the branch name          
        const selectedVariant = document.querySelector(`input[type="radio"][value="${selectedBranch}"]`);
        if (!selectedVariant) return;
        // 
        selectedVariant.checked = true;
        selectedVariant.dispatchEvent(new CustomEvent('change', { bubbles: true }));
    }
    if (document.body.classList.contains('template-product')) {
        loadProductVariantOnSelectedBranch();
        scheduleBranchZeroPriceCheck();
    }

    function escapeBranchSelector(branch) {
        if (!branch) return '';
        return typeof CSS !== 'undefined' && CSS.escape
            ? CSS.escape(branch)
            : branch.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function getProductGridItems(productGrid) {
        if (!productGrid) return [];

        const directItems = productGrid.querySelectorAll(':scope > li.grid__item');
        if (directItems.length) {
            return Array.from(directItems);
        }

        return Array.from(productGrid.querySelectorAll('ul.product-grid > li.grid__item, ul.grid > li.grid__item'));
    }

    function getBranchVariantPriceEl(container, selectedBranch) {
        if (!selectedBranch?.trim() || !container) return null;

        const normalizedBranch = selectedBranch.trim().toLowerCase();
        const variantPrices = container.querySelectorAll('.variant-price[data-branch-variant]');

        for (const el of variantPrices) {
            const branchVariant = (el.getAttribute('data-branch-variant') || '').trim().toLowerCase();
            // Some products name their variant "<Product Name> - <Branch>" instead of just "<Branch>"
            if (branchVariant === normalizedBranch || branchVariant.endsWith(' - ' + normalizedBranch)) {
                return el;
            }
        }

        return null;
    }

    function isBranchVariantUnavailable(variantPriceEl) {
        if (!variantPriceEl) return true;

        const price = parseInt(variantPriceEl.dataset.variantPrice, 10);
        const isAvailable = variantPriceEl.dataset.variantAvailable === 'true';

        return Number.isNaN(price) || price < 1 || !isAvailable;
    }

    function filterCollectionGridByBranchPrice(selectedBranch) {
        if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) {
            return;
        }

        const productGrid = document.getElementById('product-grid');
        if (!productGrid) return;

        if (usesBranchCollectionPagination()) {
            return;
        }

        const hasBranch = Boolean(selectedBranch?.trim());

        getProductGridItems(productGrid).forEach((item) => {
            if (!hasBranch) {
                item.style.display = '';
                item.classList.remove('is-branch-unavailable');
                return;
            }

            const variantPriceEl = getBranchVariantPriceEl(item, selectedBranch);
            const isUnavailable = isBranchVariantUnavailable(variantPriceEl);

            item.style.display = isUnavailable ? 'none' : '';
            item.classList.toggle('is-branch-unavailable', isUnavailable);
        });

        updateCollectionProductCount();
    }

    function formatCollectionProductCount(count) {
        const total = parseInt(count, 10);
        if (Number.isNaN(total) || total < 0) return '';

        return total === 1 ? `${total} product` : `${total} products`;
    }

    function updateCollectionProductCount() {
        if (!document.body.classList.contains('template-collection')) return;

        const productGrid = document.getElementById('product-grid');
        if (!productGrid) return;

        const selectedBranch = LS.getItem('selectedBranch');
        if (!selectedBranch?.trim()) return;

        let count = parseInt(productGrid.dataset.branchFilteredTotal || '', 10);

        if (Number.isNaN(count)) {
            count = getProductGridItems(productGrid).filter(
                (item) => item.style.display !== 'none' && !item.classList.contains('is-branch-unavailable')
            ).length;
        }

        const countText = formatCollectionProductCount(count);
        if (!countText) return;

        document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((element) => {
            element.textContent = countText;
        });

        document.querySelectorAll('.mobile-facets__count').forEach((element) => {
            if (!element.querySelector('[data-predictive-search-live-region-count-value]')) {
                element.textContent = countText;
            }
        });
    }

    window.updateCollectionProductCount = updateCollectionProductCount;

    function getCollectionSortBy() {
        const sortFromUrl = new URLSearchParams(window.location.search).get('sort_by');
        if (sortFromUrl) return sortFromUrl;

        const sortSelect = document.querySelector('#SortBy, #SortBy-mobile, select[name="sort_by"]');
        return sortSelect?.value || '';
    }

    function sortCollectionGridByBranchPrice() {
        if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) {
            return;
        }

        const sortBy = getCollectionSortBy();
        if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') {
            return;
        }

        const selectedBranch = LS?.getItem?.('selectedBranch');
        if (!selectedBranch?.trim()) {
            return;
        }

        const productGrid = document.getElementById('product-grid');
        if (!productGrid) return;

        if (usesBranchCollectionPagination()) {
            return;
        }

        const items = getProductGridItems(productGrid)
            .filter((item) => !item.classList.contains('is-branch-unavailable') && item.style.display !== 'none');
        if (items.length < 2) return;

        const itemsWithPrice = items.map((item, index) => {
            const variantPriceEl = getBranchVariantPriceEl(item, selectedBranch);
            let price = sortBy === 'price-ascending' ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;

            if (variantPriceEl) {
                const parsedPrice = parseInt(variantPriceEl.dataset.variantPrice, 10);
                if (!Number.isNaN(parsedPrice)) {
                    price = parsedPrice;
                }
            }

            return { item, price, index };
        });

        const direction = sortBy === 'price-ascending' ? 1 : -1;
        itemsWithPrice.sort((a, b) => {
            if (a.price !== b.price) return (a.price - b.price) * direction;
            return a.index - b.index;
        });

        itemsWithPrice.forEach(({ item }) => productGrid.appendChild(item));
    }

    function collectionPriceBasedOnBranch() {
        if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) {
            return;
        }

        const selectedBranch = LS?.getItem?.('selectedBranch');
        filterCollectionGridByBranchPrice(selectedBranch);

        updateCollectionProductCount();

        if (!selectedBranch) return;

        const branchSelector = escapeBranchSelector(selectedBranch);

        document.querySelectorAll('.all-variant-prices').forEach(container => {
            const variantPriceEl = container.querySelector(`.variant-price[data-branch-variant="${branchSelector}"]`);
            if (!variantPriceEl) return;

            const priceAmount = parseInt(variantPriceEl.dataset.variantPrice, 10);
            if (Number.isNaN(priceAmount) || priceAmount < 1 || variantPriceEl.dataset.variantAvailable !== 'true') return;

            variantPriceEl.style.fontWeight = 'bold';
                // 
                const price = variantPriceEl.innerHTML;
                // 
                // Find the price element in the product card
                const productCard = container.closest(`.card__information`);
                // 
                if (productCard) {
                    const priceEl = productCard.querySelectorAll('.shown-price-amount');
                    const compareAtPriceEl = productCard.querySelectorAll('.shown-compare-at-price-amount');
                    // Update the hidden product form variant ID input
                    const productForm = productCard.querySelector('product-form .product-variant-id');
                    const productVariantId = variantPriceEl.dataset.variantId;
                    // 
                    if (productForm && productVariantId) {
                        productForm.value = productVariantId;
                    }
                    if (!priceEl) return;
                    // 
                    priceEl.forEach(el => {
                        el.innerHTML = price;
                    });

                    if (!compareAtPriceEl) return;
                    const compareAtPrice = variantPriceEl.dataset.variantCompareAtPrice;
                    const compareAtPriceAmount = parseFloat(variantPriceEl.dataset.variantCompareAtPriceAmount);
                    const priceAmount = parseFloat(variantPriceEl.dataset.variantPrice);
                    
                    compareAtPriceEl.forEach(el => {
                        if (el) {
                            if (compareAtPriceAmount && compareAtPriceAmount > 0 && compareAtPriceAmount > priceAmount) {
                                if (el.closest('s').closest('span')) {
                                    el.closest('s').closest('span').style.visibility = 'visible';
                                }
                                el.innerHTML = compareAtPrice;
                                el.style.display = 'block';
                            } else {
                                el.innerHTML = compareAtPrice;
                                el.style.display = 'none';
                                if (el.closest('s').closest('span')) {
                                    el.closest('s').closest('span').style.visibility = 'hidden';
                                }
                            }
                        }
                    });
                    
                    let productAddToCartBtn = productCard.querySelector('product-form .product-form__submit:not(.submit-btn-2)');
                    let productAddToCartBtn2 = productCard.querySelector('product-form .product-form__submit.submit-btn-2');
                    if (!productAddToCartBtn) return;

                    if (variantPriceEl.dataset.variantAvailable === 'true') {
                        productAddToCartBtn.querySelector('span').innerText = window.variantStrings.addToCartDelivery;
                        productAddToCartBtn2.querySelector('span').innerText = window.variantStrings.addToCartCollection;

                        productAddToCartBtn.disabled = false;
                        productAddToCartBtn.classList.remove('disabled');
                        productAddToCartBtn.style.cursor = 'pointer';
                        productAddToCartBtn2.disabled = false;
                        productAddToCartBtn2.classList.remove('disabled');
                        productAddToCartBtn2.style.cursor = 'pointer';
                    } else {
                        productAddToCartBtn.querySelector('span').innerText = window.variantStrings.soldOut;
                        productAddToCartBtn2.querySelector('span').innerText = window.variantStrings.soldOut;
                        productAddToCartBtn.disabled = true;
                        productAddToCartBtn.classList.add('disabled');
                        productAddToCartBtn.style.cursor = 'not-allowed';
                        productAddToCartBtn2.disabled = true;
                        productAddToCartBtn2.classList.add('disabled');
                        productAddToCartBtn2.style.cursor = 'not-allowed';
                    }

                    let skuEl = productCard.querySelector('.product-sku');
                    if (skuEl && variantPriceEl.dataset.sku) {
                        skuEl.textContent = variantPriceEl.dataset.sku;
                    }

                }
        });

        sortCollectionGridByBranchPrice();
    }

    function updateHeroPriceBasedOnBranch() {
        const selectedBranch = LS?.getItem?.('selectedBranch');

        document.querySelectorAll('.dbm-hero .dbm-card').forEach(card => {
            const variantPricesContainer = card.querySelector('.all-variant-prices');
            const priceWrapper = card.querySelector('.dbm-price__wrapper');
            const priceEl = card.querySelector('.dbm-price');
            const unitEl = card.querySelector('.dbm-price__unit');

            if (!variantPricesContainer || !priceWrapper || !priceEl) return;

            const variantPriceEl = getBranchVariantPriceEl(variantPricesContainer, selectedBranch);

            if (isBranchVariantUnavailable(variantPriceEl)) {
                priceWrapper.style.display = 'none';
                if (unitEl) unitEl.style.display = 'none';
                return;
            }

            priceEl.innerHTML = variantPriceEl.innerHTML;
        });
    }
    if (document.getElementById("ProductGridContainer")) {
        
        // Observe AJAX product grid updates
        MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        const observer = new MutationObserver(function (mutations, observer) {
            mutations.forEach(function (mutation) {
                if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
                        reinitializePostcodeElements();
                        updateProductInfoVisibility();
                    }
                }
            });
        });
        observer.observe(document.getElementById("ProductGridContainer"), {
            childList: true       
        });
    }
});
